import FileGallerySlateButtonContainer from './FileGallerySlateButtonContainer'
// import FileGallerySlateButton from './FileGallerySlateButton'
// export { FileGallerySlateButton }
export { FileGallerySlateButtonContainer }
export default FileGallerySlateButtonContainer



// WEBPACK FOOTER //
// ./src/components/FileGallerySlateButton/index.js